import { useTranslation } from 'react-i18next';
import { useIsThemeModeSelectable, useThemePreference } from '@/contexts/ThemeModeContext';
import { useUserPreferences } from '@/components/Recipe/hooks/useUserPreferences';
import ParentMenuItem from '@/components/Recipe/Menu/ParentMenuItem';
import { I18N_KEYS } from '@/language/keys';
import type { ReactNode } from 'react';

/** Shared by workflow preferences, dashboard accounts, and standalone tools. */
export function ThemeMenuItem({ lead, onClose }: { lead?: ReactNode; onClose?: () => void }) {
  const { t } = useTranslation();
  const selectable = useIsThemeModeSelectable();
  const preference = useThemePreference();
  const { handleThemeChange } = useUserPreferences();
  const labels = I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU;
  if (!selectable) return null;

  return (
    <ParentMenuItem
      label={t(labels.THEME)}
      lead={lead}
      onClose={onClose}
      items={[
        {
          type: 'radio_group',
          ariaLabel: t(labels.THEME),
          value: preference,
          options: [
            { value: 'dark', label: t(labels.THEME_DARK) },
            { value: 'light', label: t(labels.THEME_LIGHT) },
            { value: 'system', label: t(labels.THEME_SYSTEM) },
          ],
          onChange: (value) => {
            if (value === 'dark' || value === 'light' || value === 'system') void handleThemeChange(value);
            onClose?.();
          },
        },
      ]}
    />
  );
}
